"use client"

import { Suspense } from "react"
import { useQuery } from "convex/react"
import { api } from "@/convex/_generated/api"
import ShowcasePage from "@/components/showcase-page"
import { Loader2 } from "lucide-react"

function ShowcaseContent() {
  // Fetch showcase projects from Convex with real-time updates
  const projects = useQuery(api.showcase.getAllWithUrls)

  if (projects === undefined) {
    // Still loading
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-12 w-12 animate-spin text-zinc-500" />
          <p className="text-zinc-400">Loading showcase...</p>
        </div>
      </div>
    )
  }

  // Pass projects or empty array if null
  const showcaseProjects = projects || []

  return <ShowcasePage initialProjects={showcaseProjects} />
}

export default function Page() {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen">
        <div className="flex flex-col items-center gap-4">
          <Loader2 className="h-12 w-12 animate-spin text-zinc-500" />
          <p className="text-zinc-400">Loading showcase...</p>
        </div>
      </div>
    }>
      <ShowcaseContent />
    </Suspense>
  )
}